module.exports = __webpack_public_path__ + "staticcomp/img/share.8dcf701.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/9/share.jpg
// module id = QK+s
// module chunks = 39